import { ReceiptsEventType } from './../receipts.event.type';
import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import * as moment from 'moment';
import { AppEventDispatcher } from '../../../utils/AppEventDispatcher';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { EventTypes } from '../../../shared/EventTypes';
import { TweenMax, Quint } from 'gsap';

@Component({
	selector: 'app-special-filter',
	templateUrl: './special-filter.component.html',
	styleUrls: ['./special-filter.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class SpecialFilterComponent implements OnInit {

	formPeriod: FormGroup;
	periodOpened = false;

	dateBeginError = false;
	dateEndError = false;

	constructor(private route: ActivatedRoute, private router: Router, private formBuilder: FormBuilder) {
		this.formPeriod = formBuilder.group({
			'dateBegin': [null, Validators.required],
			'dateEnd': [null, Validators.required]
		});
	}

	ngOnInit() {

	}

	loadToday() {
		const dateBegin = new Date();
		const dateEnd = null;

		AppEventDispatcher.dispatch(ReceiptsEventType.UPDATE, {dateBegin: dateBegin, dateEnd: dateEnd});
	}

	loadHalfMonth() {
		const dateBegin = new Date().setDate(new Date().getDate() - 14);
		const dateEnd = null;

		AppEventDispatcher.dispatch(ReceiptsEventType.UPDATE, {dateBegin: dateBegin, dateEnd: dateEnd});
	}

	loadFullMonth() {
		const dateBegin = new Date().setDate(new Date().getDate() - 29);
		const dateEnd = null;

		AppEventDispatcher.dispatch(ReceiptsEventType.UPDATE, {dateBegin: dateBegin, dateEnd: dateEnd});
	}

	togglePeriodLayer() {
		if (this.periodOpened) {
			this.periodOpened = false;
			TweenMax.to('[data-component="special-filter"] .period-layer', .6, {autoAlpha: 0, top: 60, ease: Quint.easeOut});
		}	else {
			this.periodOpened = true;
			TweenMax.to('[data-component="special-filter"] .period-layer', .8, {autoAlpha: 1, top: 80, ease: Quint.easeOut});
		}
	}

	markButton(e) {
		$('.filter-item').removeClass('active');
		$('.btn-filter-month').removeClass('active');

		e.currentTarget.classList.add('active');
	}

	onSubmit() {

		if (!this.formPeriod.controls.dateBegin.valid) {
			this.dateBeginError = true;
		} else {
			this.dateBeginError = false;
		}

		if (!this.formPeriod.controls.dateEnd.valid) {
			this.dateEndError = true;
		} else {
			this.dateEndError = false;
		}

		if (this.formPeriod.valid) {

			if (moment(this.formPeriod.controls.dateBegin.value).isSameOrBefore(this.formPeriod.controls.dateEnd.value)) {
				this.dateBeginError = false;
				this.dateEndError = false;

				this.togglePeriodLayer();

				this.periodOpened = false;

				TweenMax.delayedCall(.4, () => {

					AppEventDispatcher.dispatch(ReceiptsEventType.UPDATE, {
						dateBegin: this.formPeriod.value.dateBegin,
						dateEnd: this.formPeriod.value.dateEnd
					});

				});

			} else {
				this.dateEndError = true;
				this.dateBeginError = true;

				AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, {msg: 'A data inicial, deve ser menor que a data final.'});
			}

		}

	}

	changeDate() {

		if (!this.formPeriod.controls.dateBegin.valid) {
			this.dateBeginError = true;
		} else {
			this.dateBeginError = false;
		}

		if (!this.formPeriod.controls.dateEnd.valid) {
			this.dateEndError = true;
		} else {
			this.dateEndError = false;
		}

	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/receipts/special-filter/special-filter.component.ts